<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-2': isAdmin, 'col-md-12 mb-0': !isAdmin }">
      <div class="form-group">
        <h3 class="text-center mb-0">
          SIA Questionnaire
        </h3>
        <h5 class="text-center bg-grey" v-if="isMarked">
          Percentage: {{ percentage }}%    Result: {{result}}
        </h5>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">1. What do you call the Private Security Industry’s Governing Body?
          <span v-if="isAdmin">
          ( {{questions.question_1.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="CallThePrivateSecurityIndustryGoverningBody"
                   v-on:change="radioOnChange('question_1', $event.target.value)"
                   v-model="siaInfoObj.question_1"
        />

        <span v-if="questions.question_1" >
          <span :class="['pill', (questions.question_1.correct) ? 'pill-green' : 'pill-red']">{{ (questions.question_1.correct) ? "Correct": "Wrong" }}</span>
        </span>


      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">2. Can you carry out licensable activities without your SIA Licence badge?
          <span v-if="isAdmin">
          ( {{questions.question_2.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="LicenseAbleActivitiesWithoutYourSIALicenseBadge"
                   v-on:change="radioOnChange('question_2', $event.target.value)"
                   v-model="siaInfoObj.question_2"
        />
        <span v-if="questions.question_2">
          <span :class="['pill', questions.question_2.correct ? 'pill-green' : 'pill-red']">{{ questions.question_2.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>


      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">3. How long does an SIA Licence valid for?
          <span v-if="isAdmin">
          ( {{questions.question_3.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="SIALicenceValid"
                   v-on:change="radioOnChange('question_3', $event.target.value)"
                   v-model="siaInfoObj.question_3"
        />
        <span v-if="questions.question_3" >
          <span :class="['pill', questions.question_3.correct ? 'pill-green' : 'pill-red']">{{ questions.question_3.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">4. What should you do if you have lost your licence?
          <span v-if="isAdmin">
          ( {{questions.question_4.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="DoIfYouHaveLostYourLicence"
                   v-on:change="radioOnChange('question_4', $event.target.value)"
                   v-model="siaInfoObj.question_4"
        />
        <span v-if="questions.question_4">
          <span :class="['pill', questions.question_4.correct ? 'pill-green' : 'pill-red']">{{ (questions.question_4.correct) ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">5. Who should you tell if you move address?
          <span v-if="isAdmin">
          ( {{questions.question_5.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="IfMoveAddress"
                   v-on:change="radioOnChange('question_5', $event.target.value)"
                   v-model="siaInfoObj.question_5"
        />
        <span v-if="questions.question_5">
          <span :class="['pill', questions.question_5.correct ? 'pill-green' : 'pill-red']">{{ questions.question_5.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">6. What should you do with your SIA Licence when you are at work?
          <span v-if="isAdmin">
          ( {{questions.question_6.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="DoWithYourSIALicenceWhenYouAreAtWork"
                   v-on:change="radioOnChange('question_6', $event.target.value)"
                   v-model="siaInfoObj.question_6"
        />
        <span v-if="questions.question_6">
          <span :class="['pill', questions.question_6.correct ? 'pill-green' : 'pill-red']">{{ questions.question_6.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">7. What should you do if you see a person attempt to steal from your site?
          <span v-if="isAdmin">
          ( {{questions.question_7.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="DoIfYouSeeAPersonAttemptToStealFromYourSite"
                   v-on:change="radioOnChange('question_7', $event.target.value)"
                   v-model="siaInfoObj.question_7"
        />
        <span v-if="questions.question_7">
          <span :class="['pill', questions.question_7.correct ? 'pill-green' : 'pill-red']">{{ questions.question_7.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">8. What is your main role as a Security Officer?
          <span v-if="isAdmin">
          ( {{questions.question_8.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="MainRoleAsASecurityOfficer"
                   v-on:change="radioOnChange('question_8', $event.target.value)"
                   v-model="siaInfoObj.question_8"
        />
        <span v-if="questions.question_8">
          <span :class="['pill', questions.question_8.correct ? 'pill-green' : 'pill-red']">{{ questions.question_8.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">9. Write down a “Hazard” that you might expect to experience every day at
          work:
          <span v-if="isAdmin">
          ( {{questions.question_9.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="HazardThatYouMightExpectToExperienceEveryDayAtWork"
                   v-on:change="radioOnChange('question_9', $event.target.value)"
                   v-model="siaInfoObj.question_9"
        />
        <span v-if="questions.question_9">
          <span :class="['pill', questions.question_9.correct ? 'pill-green' : 'pill-red']">{{ questions.question_9.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>

      <div class="form-group row align-items-center">
        <label class="col-sm-2 mb-sm-0">10. What do you call the document that tells you what to do in the event of an
          Incident on site?
          <span v-if="isAdmin">
          ( {{questions.question_10.answer}} )
        </span>
        </label>
        <app-input class="col-sm-8"
                   type="radio"
                   :list="DocumentInTheEventOfAnIncidentOnsite"
                   v-on:change="radioOnChange('question_10', $event.target.value)"
                   v-model="siaInfoObj.question_10"
        />
        <span v-if="questions.question_10">
          <span :class="['pill', questions.question_10.correct ? 'pill-green' : 'pill-red']">{{ questions.question_10.correct ? "Correct" : "Wrong" }}</span>
        </span>
      </div>
    </form>
  </div>
</template>
<script>
import {FormMixin} from "@/core/mixins/form/FormMixin";

export default {
  name: "SIADetailInfo",
  mixins: [FormMixin],
  props: {
    preloader: {
      type: Boolean,
      default: false
    },
    sia_Info: {
      type: Array,
      required: true
    },
    isAdmin : {
      type : Boolean,
      default : false
    }
  },
  mounted() {
    this.setRadionInputValues();
    this.calculateScore();
  },
  data() {
    return {
      isMarked: false,
      correct: 0,
      wrong: 0,
      total: 0,
      siaInfoObj: {},
      questions: {},
      CallThePrivateSecurityIndustryGoverningBody: [
        {id: "a", value: "(a) SIA"},
        {id: "b", value: "(b) PSC"},
        {id: "c", value: "(c) SIB"},
        {id: "d", value: "(d) PSI"},
      ],
      LicenseAbleActivitiesWithoutYourSIALicenseBadge: [
        {id: "a", value: "(a) Yes, if you have a valid license"},
        {id: "b", value: "(b) No, never"},
        {id: "c", value: "(c) Only with employer permission"},
        {id: "d", value: "(d) Only during training"},
      ],
      SIALicenceValid: [
        {id: "a", value: "(a) 1 year"},
        {id: "b", value: "(b) 2 years"},
        {id: "c", value: "(c) 3 years"},
        {id: "d", value: "(d) 5 years"},
      ],
      DoIfYouHaveLostYourLicence: [
        {id: "a", value: "(a) Report to the police and apply for a replacement from SIA"},
        {id: "b", value: "(b) Use non-front line license "},
        {id: "c", value: "(c) Continue working without it"},
        {id: "d", value: "(d) Wait for it to be found"},
      ],
      IfMoveAddress: [
        {id: "a", value: "(a) Your employer"},
        {id: "b", value: "(b) Your family"},
        {id: "c", value: "(c) The police"},
        {id: "d", value: "(d) Nobody"},
      ],
      DoWithYourSIALicenceWhenYouAreAtWork: [
        {id: "a", value: "(a) Keep it in your wallet"},
        {id: "b", value: "(b) Display it visibly"},
        {id: "c", value: "(c) Hide it in your bag"},
        {id: "d", value: "(d) Leave it at home"},
      ],
      DoIfYouSeeAPersonAttemptToStealFromYourSite: [
        {id: "a", value: "(a) Confront them immediately"},
        {id: "b", value: "(b) Ignore them"},
        {id: "c", value: "(c) Prohibit them and report to supervisor or authorities"},
        {id: "d", value: "(d) Join them in stealing"},
      ],
      MainRoleAsASecurityOfficer: [
        {id: "a", value: "(a) Customer service"},
        {id: "b", value: "(b) Law enforcement"},
        {id: "c", value: "(c) Crime prevention"},
        {id: "d", value: "(d) Building maintenance"},
      ],
      HazardThatYouMightExpectToExperienceEveryDayAtWork: [
        {id: "a", value: "(a) Slippery floors"},
        {id: "b", value: "(b) Loud sound"},
        {id: "c", value: "(c) Bright lights"},
        {id: "d", value: "(d) Friendly colleagues"},
      ],
      DocumentInTheEventOfAnIncidentOnsite: [
        {id: "a", value: "(a) SOP (Standard Operating Procedure) and Assignment Instructions document."},
        {id: "b", value: "(b) Incident Report Form"},
        {id: "c", value: "(c) Site log book "},
        {id: "d", value: "(d) Employee Handbook"},
      ],
    };
  },
  methods: {
    radioOnChange(question, value) {
      const index = this.sia_Info.findIndex((item) => item.question === question);
      if (index === -1) {
        this.sia_Info.push({question: question, answer: value});
      } else {
        this.sia_Info[index].answer = value;
      }
    },
    setRadionInputValues() {
      if (this.sia_Info && this.sia_Info.length > 0) {
        let count = 1;
        for (const siaElement of this.sia_Info) {
          this.$set(this.siaInfoObj, `question_${count}`, siaElement.answer);
          this.$set(this.questions, `question_${count}`, siaElement.verification);
          count++;
        }
      }
    },
    calculateScore(){
      this.sia_Info.forEach((value, index) => {
        if(value?.verification){
          if (value.verification.correct){
            this.correct++;
          }else{
            this.wrong++;
          }
          this.total++;
          this.isMarked = true
        }
      });
    }
  },
  computed:{
    percentage(){
      return  (this.correct/this.total * 100).toFixed(2)
    },
    result(){
      return this.percentage >= 60? "Passed": "Fail";
    }
  }

};
</script>
<style scoped>
.bg-grey{
  background: grey;
  color: white;
}
label{
  font-weight: bold;
  margin-bottom: 10px !important;
}
.pill {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 999px; /* Makes it round like a pill */
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: white;
}

.pill-green {
  background-color: green;
}

.pill-red {
  background-color: red;
}

</style>